var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveTomato(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 33,
    viewBox: "0 0 163 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 10.1562,
    x2: 1.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 10.1562,
    x2: 21.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 51.5,
    y1: 10.1562,
    x2: 51.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 31.5,
    y1: 6.94922,
    x2: 31.5,
    y2: 24.7889,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 61.5,
    y1: 6.94922,
    x2: 61.5,
    y2: 24.7889,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 71.5,
    y1: 6.94922,
    x2: 71.5,
    y2: 24.7889,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 121.5,
    y1: 6.94922,
    x2: 121.5,
    y2: 24.7889,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 151.5,
    y1: 6.94922,
    x2: 151.5,
    y2: 24.7889,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 41.5,
    y1: 10.1562,
    x2: 41.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 81.5,
    y1: 10.1562,
    x2: 81.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 91.5,
    y1: 10.1562,
    x2: 91.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 111.5,
    y1: 10.1562,
    x2: 111.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 131.5,
    y1: 10.1562,
    x2: 131.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 141.5,
    y1: 10.1562,
    x2: 141.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 161.5,
    y1: 10.1562,
    x2: 161.5,
    y2: 20.9425,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5,
    y1: 1.5,
    x2: 11.5,
    y2: 30.5611,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    y1: 1.5,
    x2: 101.5,
    y2: 30.5611,
    stroke: "#FCDDD6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveTomato);
export default __webpack_public_path__ + "static/media/waveTomato.67e3830ced6e6bb523c2db88462956a5.svg";
export { ForwardRef as ReactComponent };